import React, { useState, useEffect } from "react";
import style from "./resume.module.css";

export const ResumeComponent = ({ period, title, description }) => {
  const [height, setHeight] = useState("");

  useEffect(() => {
    const theHeight = document.getElementById(`${title}`).clientHeight;
    setHeight(theHeight);
  }, [title]);

  return (
    <div style={{ height }} className={style.Component}>
      <div className={style.Heading}>{period}</div>
      <div className={style.LineContainer}>
        <div className={style.Line}></div>
        <div className={style.Cicle}></div>
      </div>
      <div id={`${title}`} className={style.Description}>
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
};

export const Projects = ({ image, title, link, description }) => {
  const [height, setHeight] = useState("");

  useEffect(() => {
    const theHeight = document.getElementById(`${title}`).clientHeight;
    setHeight(theHeight);
  }, [title]);

  return (
    <div style={{ height }} className={style.Component}>
      <div className={style.Heading}>
        <a href={link} rel="noreferrer" target="_blank">
          <img className={style.Image} alt="_project_avatar_" src={image} />
        </a>
      </div>
      <div className={style.LineContainer}>
        {/* <div className={style.Line}></div>
        <div className={style.Cicle}></div> */}
      </div>
      <div id={`${title}`} className={style.Description}>
        <h3>
          <a href={link} rel="noreferrer" target="_blank">
            {title}
          </a>
        </h3>
        <p>{description}</p>
      </div>
    </div>
  );
};
